module.exports = __webpack_public_path__ + "img/personal_pic_bg.a3449226.png";